import { IWorkflowStep, SitePermitStatus } from '~/client/graph'
import { getWorkflowStatusSolid } from '~/client/src/shared/constants/workflowStatusColors'
import { TagType } from '~/client/src/shared/enums/TagType'
import { getFormStatusDisplayName } from '~/client/src/shared/localization/enumDisplayTexts'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import Tag, { ITag } from '~/client/src/shared/models/Tag'
import { enumToList } from '~/client/src/shared/utils/converters'

const getStatusText = (status: string, isLate?: boolean) => {
  return isLate ? status + ', ' + Localization.translator.late : status
}

export const getFormsStatusAsTag = (
  status: SitePermitStatus,
  workflowStepLevel?: number,
  isLate?: boolean,
): ITag => {
  const color = getWorkflowStatusSolid(status, isLate)
  const name = getStatusText(
    getFormStatusDisplayName(status, workflowStepLevel),
    isLate,
  )

  return new Tag(status, name, color, status, TagType.Status)
}

export const getFormsStatusesAsTags = (): ITag[] => {
  return enumToList(SitePermitStatus).map(status => getFormsStatusAsTag(status))
}

export const getWorkflowStepLevel = (
  stepId: string,
  workflowSteps: IWorkflowStep[],
): number => {
  const step = workflowSteps.find(s => s.id === stepId)
  const sameSteps = workflowSteps.filter(s => !!step && s.type === step?.type)

  if (sameSteps.length <= 1) return 0

  const stepIndex = sameSteps.findIndex(s => s.id === stepId)
  return stepIndex === -1 ? 0 : stepIndex + 1
}
